// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-ChapterAnimation----index-module---root---315iS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChapterAnimation/index.module.css
// module id = 143
// module chunks = 53243946022428 164721891013254 277786696673472